/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

import cleanUpResponse from '@/util/cleanUpResponse';
import { formatServerDate, formatServerDateTime, parseDisplayDate, parseDisplayDateTime } from '@/util/MomentUtils';

export default async function UpdateAWPackageInformation(formData) {
  const AWPackage = {
    ID: formData.awPackageId,
    SubmittedOn: formatServerDateTime(parseDisplayDateTime(formData.submittedOn)),
    KOStatusDateReq: formatServerDate(parseDisplayDate(formData.koStatusDateReq)),
    FiscalYear: formData.fiscalYear,
    FundingCenterID: formData.fundingCenterId,
    CostCenterID: formData.costCenterId,
    ObjectClassID: formData.objectClassId,
    InternalOrderNumberID: formData.internalOrderNumberId,
    RegionGroupID: formData.regionGroupId
  };

  if (formData.fundingSourceId) {
    AWPackage.FundingSourceID = formData.fundingSourceId;
  }

  const response = await $.soap({
    body: {
      UpdateAWPackageInformation: {
        $xmlns: 'http://dla.mil/ems/bpm/aw_package',
        AWPackage,
        AWPackageContractExtensions: {
          AWPackageContractExtension: _.map(formData.awPackageContractExtensions, (contractExtension) => {
            return {
              ContractExtensionTypeID: contractExtension.contractExtensionTypeId,
              ExtensionEndDate: formatServerDate(parseDisplayDate(contractExtension.extensionEndDate)),
              PIINSPIIN: contractExtension.piinspiin,
              AWPackageContractExtensionFDRs: {
                AWPackageContractExtensionFDR: _.map(contractExtension.awPackageContractExtensionFdrs, (fdr) => {
                  return {
                    AWFDRNum: fdr.awfdrNum
                  };
                })
              }
            };
          })
        }
      }
    }
  });
  cleanUpResponse(response);
  return response;
}
